import { render, staticRenderFns } from "./TransferCreate.vue?vue&type=template&id=50a706fc"
import script from "./TransferCreate.vue?vue&type=script&lang=js"
export * from "./TransferCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports